import * as DateFns from "date-fns"

export const formatToDate = (date: Date) =>
  DateFns.format(date, "EEE do MMM")
